const STORAGE_KEY = 'momentGolf-ls-lastHole';

interface LastHoleRecord {
    scoreCode: string;
    round: number;
    hole: number;
    updatedAt: string;
}

export function saveLastHole(scoreCode: string, round: number, hole: number): void {
    if (!scoreCode || !Number.isFinite(round) || round <= 0 || !Number.isFinite(hole) || hole <= 0) {
        return;
    }

    try {
        const record: LastHoleRecord = {
            scoreCode: scoreCode.replace('-admin', '').toUpperCase(),
            round,
            hole: Math.round(hole),
            updatedAt: new Date().toISOString(),
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    } catch {
        // non-fatal
    }
}

export function getLastHole(scoreCode: string, round: number): number | null {
    if (!scoreCode || !Number.isFinite(round) || round <= 0) {
        return null;
    }

    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;

        const parsed = JSON.parse(raw) as LastHoleRecord;
        const normalizedCode = scoreCode.replace('-admin', '').toUpperCase();

        if (
            parsed?.scoreCode === normalizedCode &&
            parsed?.round === round &&
            Number.isFinite(parsed.hole) &&
            parsed.hole > 0
        ) {
            return Math.round(parsed.hole);
        }
    } catch {
        // non-fatal
    }

    return null;
}

export function clearLastHole(): void {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch {
        // non-fatal
    }
}
